import { Module } from 'vuex-smart-module';
import AuthActions from './actions';
import AuthGetters from './getters';
import AuthMutations from './mutations';
import AuthState from './state';

export default new Module({
  state: AuthState,
  mutations: AuthMutations,
  actions: AuthActions,
  getters: AuthGetters,
});
